var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { colors, devices } from '../../../base/styled/variables.styled';
import { typography } from "../../../base/styled/typography.style";
export const ChevronIcon = styled.svg.attrs({
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    children: (_jsx("path", { d: "M10.8284 12.0007L15.7782 16.9504L14.364 18.3646L8 12.0007L14.364 5.63672L15.7782 7.05093L10.8284 12.0007Z" }))
}) `
  width: 24px;
  height: 24px;
`;
export const EllipsisIcon = styled.svg.attrs({
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    children: (_jsx("path", { d: "M4.5 10.5C3.675 10.5 3 11.175 3 12C3 12.825 3.675 13.5 4.5 13.5C5.325 13.5 6 12.825 6 12C6 11.175 5.325 10.5 4.5 10.5ZM19.5 10.5C18.675 10.5 18 11.175 18 12C18 12.825 18.675 13.5 19.5 13.5C20.325 13.5 21 12.825 21 12C21 11.175 20.325 10.5 19.5 10.5ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z" }))
}) `
  width: 24px;
  height: 24px;
`;
export const StyledTagContainer = styled.div `
  position: relative;
  width: 100%;
  max-width: 768px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 48px;

	@media ${devices.mobile} {
		padding: 0 16px;
	}

`;
export const StyledTagsWrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  position: relative;
  padding: 3px;
  margin: -3px;

  ${({ showAll }) => !showAll && css `
    max-height: 46px;
    overflow: hidden;

		@media ${devices.tablets} {
      max-height: 86px;
    }
  `}
`;
const _a = typography.legend, { color: _color, fontWeight: _fontWeight } = _a, legendStyles = __rest(_a, ["color", "fontWeight"]);
export const StyledTag = styled.a.withConfig({
    shouldForwardProp: (prop) => !['variant', 'isMoreButton', 'isShowLessButton'].includes(prop),
}) `
  ${legendStyles}
	font-weight: 700;
	text-transform: uppercase;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px;
  border-radius: 999px;
  border: none;
  cursor: ${({ variant, isMoreButton, isShowLessButton }) => (variant === 'action' || isMoreButton || isShowLessButton) ? 'pointer' : 'default'};
  transition: background-color 0.3s ease, color 0.3s ease;
  white-space: nowrap;
  user-select: none;

  ${({ variant }) => variant === 'decorative' && css `
    background-color: ${colors.greenMenta};
    color: ${colors.brand500};
    cursor: default;
    pointer-events: none;
  `}

  ${({ variant, isMoreButton, isShowLessButton }) => (variant === 'action' || isMoreButton || isShowLessButton) && css `
    background-color: transparent;
    color: ${colors.brand500};
    border: 2px solid ${colors.brand500};

    &:hover {
      background-color: ${colors.brand75};
    }

    &:focus-visible {
      background-color: ${colors.brand75};
      outline: 3px solid ${colors.brand300};
    }
  `}

	${({ isMoreButton }) => isMoreButton && css `
		padding: 7px 8px;
  `}

	${({ isShowLessButton }) => isShowLessButton && css `
		padding: 7px 8px;
  `}
`;
//# sourceMappingURL=Tag.style.js.map